<canvas baseChart [data]="activeChart.data" [options]="activeChart.options" [type]="activeChart.type" width="100%" height="30em"></canvas>
